module.exports = __webpack_public_path__ + "img/successfactors.98cd58d2.png";